'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _propertyOf2 = require('lodash/fp/propertyOf');

var _propertyOf3 = _interopRequireDefault(_propertyOf2);

var _get2 = require('lodash/fp/get');

var _get3 = _interopRequireDefault(_get2);

var _flow2 = require('lodash/fp/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _capeStyle = require('cape-style');

var _capeStyle2 = _interopRequireDefault(_capeStyle);

var _NavItem = require('./NavItem');

var _NavItem2 = _interopRequireDefault(_NavItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Menu(_ref) {
  var activeId = _ref.activeId,
      className = _ref.className,
      links = _ref.links,
      actions = _ref.actions,
      styles = _ref.styles;

  var getAction = (0, _flow3.default)((0, _get3.default)('action'), (0, _propertyOf3.default)(actions));
  function isActive(_ref2) {
    var id = _ref2.id;
    return activeId === id;
  }
  return _react2.default.createElement(
    'ul',
    { className: (0, _classnames2.default)(className, 'menu'), style: (0, _capeStyle2.default)('lsNone p0', styles.menu) },
    (0, _map3.default)(links, function (link) {
      return _react2.default.createElement(_NavItem2.default, _extends({}, link, { key: link.id, action: getAction(link), isActive: isActive(link) }));
    })
  );
}
Menu.propTypes = {
  activeId: _propTypes2.default.string,
  className: _propTypes2.default.string,
  links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired
  })).isRequired,
  actions: _propTypes2.default.objectOf(_propTypes2.default.func).isRequired,
  styles: _propTypes2.default.objectOf(_propTypes2.default.object)
};
Menu.defaultProps = {
  activeId: null,
  className: null,
  styles: {
    menu: {},
    links: {}
  }
};
exports.default = Menu;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/Menu/MenuEl.js
// module id = 694
// module chunks = 0